import { parseJsonString } from 'pano-utils';

export type StandardSubtitle = {
  startTime: number;
  endTime: number;
  text: string;
};

type AliStyleSubtitle = {
  begin_time: string;
  end_time: string;
  text: string;
};

type SubtitleList = StandardSubtitle[] | AliStyleSubtitle[];

const isAliStyle = (list: SubtitleList): list is AliStyleSubtitle[] => {
  if (!list.length) return false;
  return 'begin_time' in list[0];
};

export function subtitleFormat(srt: string) {
  try {
    const list = parseJsonString(srt) as SubtitleList;
    if (isAliStyle(list)) {
      const newList: StandardSubtitle[] = list.map((item) => ({
        startTime: Number(item.begin_time),
        endTime: Number(item.end_time),
        text: item.text,
      }));
      return JSON.stringify(newList);
    }
    return srt;
  } catch (e) {
    return '';
  }
}
